import classNames from 'classnames';

import Select from '../Select/Select';
import type { SelectOption } from '../../../types';

import styles from './MenuSelectItem.module.less';

/**
 * MenuSelectItem Component
 *
 * Part of the Menu system for selecting a single option.
 * Integrates with the Menu for consistent styling and functionality.
 */
const MenuSelectItem = ({
  id,
  options,
  value,
  onChange,
  size = 'medium',
}: {
  id: string;
  options: SelectOption[];
  value: SelectOption | null;
  onChange: (option: SelectOption | null) => void;
  size?: 'small' | 'medium' | 'large';
}) => (
  <Select
    id={id}
    options={options}
    value={value}
    onChange={onChange}
    className={classNames(styles.container, styles[size])}
    classNames={{
      control: () => styles.control,
      singleValue: () => styles.singleValue,
      option: () => styles.option,
      indicatorSeparator: () => styles.indicatorSeparator,
    }}
    isSearchable={false}
    isClearable={false}
  />
);

export default MenuSelectItem;
